import type { SupportedLocale } from '../types/simulation'
import translations from './onboarding-showcase.json'

export type OnboardingShowcaseKey = 'face' | 'time' | 'outfit' | 'decor' | 'pixar' | 'area'

export const onboardingShowcaseCopy: Record<SupportedLocale, Record<OnboardingShowcaseKey, { title: string; body: string }>> = translations
